var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 13,
    viewBox: "0 0 20 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.701 5.44851C18.2392 3.85382 14.5183 0 10 0C5.48173 0 1.62791 3.85382 0.299003 5.5814C-0.0996678 5.98007 -0.0996678 6.64452 0.299003 7.04319C1.62791 8.77077 5.48173 12.4917 10 12.4917C14.3854 12.4917 18.2392 8.63788 19.701 7.04319C20.0997 6.51163 20.0997 5.98007 19.701 5.44851ZM10 10.6312C7.60797 10.6312 5.61462 8.63787 5.61462 6.24585C5.61462 3.85382 7.60797 1.86046 10 1.86046C12.392 1.86046 14.3854 3.85382 14.3854 6.24585C14.3854 8.63787 12.392 10.6312 10 10.6312Z",
    fill: "#212A37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9684 6.24579C12.9684 7.88579 11.64 9.2142 10 9.2142C8.36001 9.2142 7.03159 7.88579 7.03159 6.24579C7.03159 4.60578 8.36001 3.27734 10 3.27734C10.4779 3.27734 10.9284 3.38893 11.3263 3.58894C10.5747 3.70261 10 4.35105 10 5.1342C10 5.99738 10.699 6.69631 11.5621 6.69631C12.1621 6.69631 12.6821 6.35948 12.9432 5.86472C12.96 5.98895 12.9684 6.11737 12.9684 6.24579Z",
    fill: "#212A37"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.2a0d875ec9b1d54cfe34b625873ee6d5.svg";
export { ForwardRef as ReactComponent };